import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IAccessibleViewService = ( createDecorator('accessibleViewService'));
export { IAccessibleViewService };
